"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../utils/prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GridView = function GridView(_ref) {
  var ListItemViewClass = _ref.ListItemViewClass,
      onItemClick = _ref.onItemClick,
      contentTypes = _ref.contentTypes;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "",
    className: "resources outer-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inner-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-type-container outer-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inner-container"
  }, contentTypes.map(function (contentType) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "content-type",
      id: "content-type-".concat(contentType.id),
      key: contentType.id
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "grid-view__header"
    }, /*#__PURE__*/_react["default"].createElement("h4", null, contentType.name, /*#__PURE__*/_react["default"].createElement("span", {
      className: "content-type-count"
    }, contentType.filteredItems.length), /*#__PURE__*/_react["default"].createElement("span", {
      className: "content-type-expander"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "content-type-files"
    }, contentType.filteredItems.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(ListItemViewClass, {
        key: item.id,
        item: item,
        onItemClick: onItemClick,
        index: index
      });
    })));
  })))));
};

GridView.propTypes = {
  ListItemViewClass: _propTypes["default"].func.isRequired,
  contentTypes: _propTypes2["default"].contentTypes.isRequired,
  onItemClick: _propTypes["default"].func.isRequired
};
var _default = GridView;
exports["default"] = _default;